{
  "title": "Casino Cashback",
  "yourLevel": "SEVİYENİZ",
  "completed": "TAMAMLANDI",
  "locked": "KİLİTLİ",
  "xpLabel": "Tecrübe",
  "xpRule": "Tecrübe hesabı: €1 bahis = {{xp}} tecrübe puanı",
  "cashback": "Cashback {{pct}}%",
  "cashbackMax": "Cashback {{lo}}% - {{hi}}%",
  "daily": "Günlük",
  "everyDays": "{{days}} günde bir",
  "active": "Aktif: AZN {{amount}}",
  "claim": "AL",
  "howTitle": "Nasıl çalışır?",
  "how1": "Favori slot ve oyunlarınızı oynayın",
  "how2": "Tecrübe kazanın ve seviyenizi yükseltin",
  "how3": "Cashback ve ödüller alın",
  "lockedNote": "«{{name}}» seviyesine ulaşmak için daha fazla tecrübe gerekir",
  "loginHint": "XP, cashback ve alma için giriş yapın",
  "login": "Giriş yap",
  "history": "Geçmiş",
  "historyEmpty": "Henüz kayıt yok.",
  "claimTitle": "Cashback al",
  "claimAmount": "Tutar: {{amount}} AZN",
  "claimNote": "Doğrudan gerçek bakiyeye. Wagering: 0x.",
  "cancel": "İptal",
  "confirm": "Onayla",
  "congrats": "Tebrikler!",
  "newLevel": "Yeni VIP seviye: {{name}}",
  "continue": "Devam",
  "infoBody": "Sadece gerçek paralı casino bahisleri XP ve cashback üretir. Bonus, spor ve demo dahil değil. 24s bekleme ve min 1 AZN.",
  "close": "Kapat",
  "maxNote": "VIP MAX — XP durur. Kategori ciro cashback.",
  "level_1": "Bakır",
  "level_2": "Bronz",
  "level_3": "Gümüş",
  "level_4": "Altın",
  "level_5": "Yakut",
  "level_6": "Safir",
  "level_7": "Elmas",
  "level_8": "VIP SEVİYE",
  "maintenance": "Bakım — alma geçici kapalı.",
  "rulesTitle": "KURALLAR",
  "lockedShort": "KİLİTLİ",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir"
}
